










































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import moment from "moment";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import { SuketSehatJiwaMmpiInterface } from "@/types/suket_sehat_jiwa_mmpi";
import StoreSuketSehatJiwaMmpi from "@/store/modules/SuketSehatJiwaMmpi";
import SuketSehatJiwaMmpi from "@/services/SuketSehatJiwaMmpi";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import SuketSehatJiwaMmpiInputCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketSehatJiwaMmpiInputCard.vue";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    SuketSehatJiwaMmpiInputCard
  },
  inject: {
    pageIsReadOnly: { from: "isReadOnly", default: () => () => false }
  }
})
export default class SuketSehatJiwaMmpiTabPage extends Vue {
  @Prop() readonly register!: string;
  pageIsReadOnly!: () => boolean;

  expandInput = false;
  pageTab = "tab-soap";
  allowedUnit = ["13", "2E", "2Q"];
  modalTtd = false;

  get dataSuket(): SuketSehatJiwaMmpiInterface {
    return StoreSuketSehatJiwaMmpi.suket;
  }

  get tglSurat() {
    return moment(this.dataSuket?.surat_date).format("DD-MM-YYYY");
  }

  get loadContent() {
    return StoreSuketSehatJiwaMmpi.loading;
  }

  get creatorUserId() {
    return this.dataSuket?.creator_user_id;
  }

  get signeeUserId() {
    return this.dataSuket?.signee_user_id;
  }

  get isReadOnly() {
    if (this.pageIsReadOnly()) return true;
    return !this.allowedUnit.includes(userModule.user.unit_id);
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    SuketSehatJiwaMmpi.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
  }

  showSignatureModal() {
    this.modalTtd = true;
  }

  passTtd(value) {
    appModule.setLoading(true);

    SuketSehatJiwaMmpi.sign(this.dataSuket.id, { password: value })
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan SKDP");
          appModule.addMsgTtd("");
          StoreSuketSehatJiwaMmpi.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.modalTtd = false;
      });
  }
}
